import React, {Component} from 'react';
import {connect} from 'react-redux';

import NewNonEngineer from './NewNonEngineerContainer';
import NonEngineers from '../../shared/NonEngineers';

import {
    fetchBranches,
    fetchNonEngineers,
    updateNonEngineer,
    uploadNonEngineerDocument,
    deleteNonEngineerDocument,
} from '../../../actions';

class NonEngineersContainer extends Component {
    componentDidMount() {
        const {belongsTo, fetchBranches} = this.props;
        return fetchBranches(belongsTo);
    }
    render() {
        const generateUrl = (belongsTo, nonEngineer, doc) => {
            return `/api/landlord/${belongsTo}/dlo/non-engineers/${nonEngineer}/documents/${doc}`;
        };
        return <NonEngineers NewNonEngineer={NewNonEngineer} generateDocUrl={generateUrl} {...this.props}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        belongsTo: state.me.application.id,
        engineers: state.landlord.dlo.nonEngineers,
        settings: state.landlord.dlo.settings.data,
        branches: state.landlord.branches
    }
};

export default connect(mapStateToProps, {
    fetchBranches,
    fetchNonEngineers,
    updateNonEngineer,
    uploadNonEngineerDocument,
    deleteNonEngineerDocument,
})(NonEngineersContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/DLO/NonEngineersContainer.js